// extracted by mini-css-extract-plugin
export default {"nav":"Layout_nav__Z+jNr","cloud":"Layout_cloud__prAty","title":"Layout_title__fkl8y","main":"Layout_main__2mhdy"};